// Azura: transparenter Header über dem Hero auf der Startseite, cremefarben sobald gescrollt wird.
// Ergänzt Dawns sticky-header-Verhalten, ersetzt es nicht.
(function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  var main = document.querySelector('main[data-template]');
  if (!headerWrapper || !main || main.dataset.template !== 'index') return;

  var heroWithImage = document.querySelector('.azura-hero[data-has-image="true"]');
  if (!heroWithImage) return;

  headerWrapper.classList.add('header-wrapper--transparent-home');

  function updateScrolled() {
    var scrolled = window.scrollY > 40;
    headerWrapper.classList.toggle('header-wrapper--scrolled', scrolled);
  }

  updateScrolled();
  window.addEventListener('scroll', updateScrolled, { passive: true });
})();
